import $ from 'jquery';
import '../../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/scrollspy';
import * as helpers from './helpers';
import {els, constants, breakpoints} from './variables';

function addLinksToTOC() {
	var content = document.querySelectorAll("#primary-content .content__inner")[0];
	var toc = document.getElementById("table-of-contents");
	var headings = content.querySelectorAll("h2, h3, h4, h5, h6");
	var tocItems;
	var prevLevel = false;
	var parentEl = toc;
	var prevEl = parentEl;
	for(var i = 0, l = headings.length; i < l; i++) {
		var heading = headings[i];
		var text = heading.childNodes[0].nodeValue;
		var slug = helpers.slugify(text);
		heading.id = slug;
		heading.setAttribute("data-magellan-target", slug);

		tocItems = toc.getElementsByTagName("li");

		var level = parseInt(heading.tagName.replace(/\D/g,''));
		if(prevLevel) {
			if(level > prevLevel) {
				var ul = document.createElement("ul");
				tocItems[tocItems.length - 1].appendChild(ul);
				parentEl = ul;
				prevEl = tocItems[tocItems.length - 1].parentElement;
			} else if(level < prevLevel) {
				parentEl = prevEl;
			}
		}
		prevLevel = level;

		var li = document.createElement("li");
		var a = document.createElement("a");
		var aText = document.createTextNode(text);
		a.href = "#" + heading.id;
		a.appendChild(aText);
		li.appendChild(a);
		parentEl.appendChild(li);

		// Set pathname and hostname in order for smooth scrolling to work for IE.
		// This breaks the Scrollspy functionality, unfortunately, but the experience
		// is still fine for the user.
		if($("body").hasClass("ie")) {
			a.pathname = !a.pathname ? location.pathname : a.pathname;
			a.hostname = !a.hostname ? location.hostname : a.hostname;
		}
	}
}

function handleTableOfContentsView(e) {
	if(els.viewport.width() >= breakpoints.sm) {
		$('body').removeClass('toc-open');
	}
}

function initTableOfContents() {

	if($("#table-of-contents").length > 0) {

		addLinksToTOC();

		/**
		 * Bootstrap Sticky Nav
		 * @link http://getbootstrap.com/javascript/#affix
		 */
		var stickyNav = $('nav.sticky');


		/**
		 * Bootstrap scrollspy
		 * @link http://getbootstrap.com/javascript/#scrollspy
		 */
		$('body').scrollspy({
			target: '#table-of-contents-wrap',
			offset: els.header.outerHeight() + constants.scrollTopOffset
		});

		stickyNav.find(".sidebar__inner").on("scroll", function() {
			if(this.scrollTop > 5) {
				stickyNav.addClass("scrolling");
			} else {
				stickyNav.removeClass("scrolling");
			}
		});

		$(document).on('click', '.sidebar-toggle-open #table-of-contents a', function() {
			$('#sidebar-nav-toggle-control').click();
		});

		handleTableOfContentsView();
	}
}

document.addEventListener('DOMContentLoaded', initTableOfContents);
window.addEventListener('resize', helpers.debounce(handleTableOfContentsView));
